// ============================================================
// content_helper.js
// All portfolio content extracted from resume data
// ============================================================

// Local asset imports
import ProfilePhoto from './assets/Dinesh_IT_Professional.png';
import IoTifyImg from './assets/IoTify.png';
import LinkedinBanner from './assets/Linkedin banner.png';
import DeskImg from './assets/desk.png';
import MetrashImg from './assets/Metrash.webp';
import QatarRailImg from './assets/Qatar Rail.jpg';
import HukoomiImg from './assets/Hukoomi.jpg';
import YatraConnectImg from './assets/YatraConnect.png';

export const images = {
  profile: ProfilePhoto,
  iotify: IoTifyImg,
  linkedinBanner: LinkedinBanner,
  desk: DeskImg,
};

export const profile = {
  name: "Dineshkumar Nataraj",
  title: "Senior Full Stack & Mobile Developer",
  tagline: "Senior Solutions Architect",
  email: "dineshnataraj345@outlook.com",
  phone: ["+974 71271142", "+91 9865137249"],
  linkedin: "https://www.linkedin.com/in/dineshkumar-nataraj-a83ba2192/",
  gitlab: "https://gitlab.com/dinesh_kumar_dk",
  location: {
    current: "Doha, Qatar",
    native: "India",
  },
  summary:
    "Senior Full Stack & Mobile Developer with 6+ years of experience delivering high-scale web and mobile applications. Specialized in React, Next.js, React Native, and cloud-native architecture. Proven impact in government-grade platforms, app store publishing, and performance optimization. Strong focus on scalable systems, clean architecture, and user-centric design.",
  motto: "Scale with Precision, Design with Empathy",
};

// ============================================================
// CAREER HIGHLIGHTS
// ============================================================
export const careerHighlights = [
  "Delivered government platforms (MOI, Qatar Rail, Hayya) used by thousands of users",
  "Published multiple mobile apps on Apple App Store with production-scale usage",
  "Built scalable multilingual applications (Arabic/English) with optimized performance",
  "Implemented CI/CD pipelines reducing deployment time and errors",
  "Designed reusable component systems improving development efficiency",
];

// ============================================================
// STATS / METRICS
// ============================================================
export const stats = [
  { label: "Years Experience", value: "6+" },
  { label: "Projects Delivered", value: "20+" },
  { label: "Gov Platforms", value: "12+" },
  // { label: "Active Users", value: "4M+" },
  // { label: "System Uptime", value: "99.9%" },
];

// ============================================================
// TECHNICAL SKILLS
// ============================================================
export const skills = {
  frontend: [
    "React / Next.js / Angular",
    "TypeScript / JavaScript",
    "HTML / Tailwind CSS",
    "Redux Toolkit – Thunk, Saga",
    "Gatsby",
    "Material UI / Ant Design",
    "i18n Translations (Arabic/English)",
  ],
  mobile: [
    "React Native",
    "Kony / HCL Volt MX",
    "Swift / iOS",
    "FCM Push Notifications",
    "App Store Publishing (iOS & Android)",
    "Lottie GIF Integration",
    "Offline DB & State Management",
    "Mobile Security & SSO",
    "CI/CD Pipelines",
  ],
  backend: [
    "Node.js / Express",
    "Ruby on Rails (MVC)",
    "PostgreSQL / Supabase",
    "GraphQL",
    "Redis Caching / Elastic Search",
    "REST APIs / Microservices",
    "Strapi CMS",
    "JWT / Authentication",
    "SOAP XML / Orchestration",
  ],
  devops: [
    "AWS / GCP / DigitalOcean",
    "Docker Containerization",
    "Raspberry Pi (DietPi OS)",
    "CI/CD Pipelines (GitLab CI)",
    "Microservices Architecture",
    "Gray Log / Honey Badger Monitoring",
    "Uptime Robot",
  ],
  ai: [
    "Ollama (Local LLM Models)",
    "OpenAI API Integration",
    "Prompt Engineering",
    "Chatbot Development",
    "AI-Assisted Development (Claude, Antigravity, Cursor)",
    "LLM Workflows & Embeddings",
    "Q&A Systems & Automation",
  ],
  tools: [
    "VS Code / Xcode / Sublime",
    "Postman / Swagger",
    "Azure DevOps / JIRA / ClickUp / Confluence",
    "Git / GitLab / Bitbucket",
    "DBeaver (PostgreSQL)",
    "Volt MX / Kony Visualizer",
  ],
};

// ============================================================
// PROFESSIONAL EXPERIENCE
// ============================================================
export const experiences = [
  {
    id: "applab",
    company: "Applab",
    location: "Doha, Qatar",
    period: "2023 – Present",
    isOnsite: true,
    summary:
      "Developed Metrash, CMS (Strapi), Qatar Rail, and Hayya platforms at national scale. Implemented payment systems, push notifications, and secure APIs. Improved UI performance and reduced load times. Led multilingual implementation (Arabic/English).",
    highlights: [
      "Developed Metrash, CMS (Strapi), Qatar Rail, and Hayya platforms at national scale",
      "Implemented payment systems, push notifications, and secure APIs",
      "Improved UI performance and reduced load times through optimization",
      "Led multilingual implementation (Arabic/English)",
    ],
    projects: [
      {
        name: "MetrashX CMS",
        period: "Dec 2024 – Present",
        client: "Ministry of Interior (MOI)",
        role: "Full Stack Developer",
        tech: ["Strapi", "PostgreSQL", "NodeJS", "Volt MX Foundry", "i18n"],
        description:
          "Strapi CMS application with PostgreSQL database, NodeJS API integrations in Volt MX Foundry, i18n Translations, UI Implementation and Custom components.",
        points: [
          "Strapi Application with PostgreSQL Database",
          "NodeJS, APIs are integrations in Volt MX foundry",
          "i18n Translations, UI Implementation, Custom components",
        ],
      },
      {
        name: "Qatar Survey",
        period: "Nov 2024 – Dec 2024",
        client: "Ministry of Interior (MOI)",
        role: "Angular Developer",
        tech: ["Angular", "i18n", "QID Validation", "Face Recognition"],
        description:
          "Angular JS website where Qatari citizens scan their QID and face for validation to receive a paper ballot.",
        points: [
          "Angular JS Website",
          "QID and Face scan validation system",
          "i18n Translations, UI Implementation, Custom components",
        ],
      },
      {
        name: "Metrash2",
        period: "Aug 2024 – Nov 2024",
        client: "Ministry of Interior (MOI)",
        role: "Kony Mobile Developer",
        tech: [
          "Kony",
          "Kony Fabric",
          "SOAP XML",
          "Payment Integration",
          "Push Notifications",
        ],
        description:
          "Mobile security ecosystem platform with Kony Fabric integration, payment integration, and push notifications.",
        points: [
          "Kony Fabric Integration, Orchestration, Pre and Post processor, SOAP XML",
          "i18n Translations, UI Implementation, Custom components, Web browser",
          "Free Form Architecture, Payment integration, Kony push notification system",
        ],
      },
      {
        name: "Qatar Rail",
        period: "Dec 2023 – Aug 2024",
        client: "Qatar Rail",
        role: "VoltMX Kony Developer",
        tech: ["VoltMX", "Kony", "Push Notifications", "Payment", "i18n"],
        description:
          "End-to-end transportation management suite featuring real-time tracking, ticketing logic, and passenger data synchronization.",
        points: [
          "VoltMX Foundry Integration, Kony push notification, VoltMX Preview",
          "i18n Translations, UI Implementation, Custom components, Payment",
        ],
        image:
          "https://qatarcool.com/qa/wp-content/uploads/2018/07/Doha-Metro.jpg",
      },
      {
        name: "Hayya",
        period: "Sep 2023 – Dec 2023",
        client: "Qatar Government",
        role: "Next.js Developer",
        tech: ["Next.js", "Redux", "i18n", "Stepper Forms", "Carousel"],
        description:
          "Sophisticated large-scale fan portal integrated with multiple national databases for event management and visitor authentication (FIFA World Cup).",
        points: [
          "Apply Hayya Stepper Form",
          "Carousel implementation",
          "i18n Translations Arabic/English",
          "Redux state management",
        ],
        image:
          "https://d12eu00glpdtk2.cloudfront.net/public/images/news/hayya-platform-processes-over-2-million-e-visa-applications-post-fifa-qatar-2022/_910x600_clip_center-center_none/hayya-platform-processes-over-2-million-e-visa-applications-post-fifa-qatar-2022.jpg",
      },
      {
        name: "Hukoomi",
        period: "Mar 2023 – Sep 2023",
        client: "Qatar Government",
        role: "React Developer",
        tech: ["React", "OpenAI", "Cognitive Search", "Webpack", "Docker", "i18n"],
        description:
          "Government portal with AI chatbot integration, cognitive search, and multilingual support.",
        points: [
          "Chatbot, OpenAI integration, Suggestions and Autocomplete while searching",
          "Cognitive search Implementation, SEO Meta Tag, Webpack config",
          "React integrated and used through the Dotnet Docker",
          "Reusable Components & Wrappers, i18n Translations Arabic/English",
          "Retrieve data from App settings through Redux",
        ],
        image:
          "https://d12eu00glpdtk2.cloudfront.net/public/images/local/_760x500_clip_center-center_none/hukoomi_banner-03_1_191104_180206.jpg",
      },
    ],
  },
  {
    id: "appstation",
    company: "Appstation",
    location: "Trivandrum, India",
    period: "Sep 2022 – Mar 2023",
    isOnsite: false,
    summary:
      "Worked with Redux and TypeScript for scalable state management. Built Next.js applications with SSR, Redux Toolkit, Saga and Thunk. Built scalable charity and chatbot platforms using modern frameworks.",
    highlights: [
      "Worked with Redux and Typescript for scalable state management",
      "Next JS Applications with SSR and Redux Toolkit, Saga and Thunk",
      "Built scalable charity and chatbot platforms using modern frameworks",
    ],
    projects: [
      {
        name: "Social Charity System",
        client: "Qatar",
        role: "React Developer",
        tech: ["React", "TypeScript", "Redux"],
        description:
          "Platform entirely built for donating amounts and goods for people with disabilities in Qatar.",
        points: [
          "Donation management for disability support",
          "Redux & TypeScript for state management",
        ],
      },
      {
        name: "Qatar Foundation",
        client: "Qatar Foundation",
        role: "Gatsby Developer",
        tech: ["Gatsby", "GraphQL"],
        description: "Enterprise web platform built using Gatsby.",
        points: ["Enterprise Web Platform", "Gatsby-based architecture"],
      },
      {
        name: "Loom",
        client: "Internal",
        role: "Next.js Developer",
        tech: ["Next.js"],
        description: "Built using Next.js framework.",
        points: ["Next.js implementation"],
      },
      {
        name: "MOCI Chatbot",
        client: "MOCI",
        role: "React Developer",
        tech: ["React", "Chatbot"],
        description: "Ministry of Commerce and Industry chatbot integration.",
        points: ["Chatbot development and integration"],
      },
    ],
  },
  {
    id: "infovision",
    company: "Infovision Solution India PVT.LTD",
    location: "Coimbatore, India",
    period: "Jun 2021 – Aug 2022",
    isOnsite: false,
    summary:
      "Developed enterprise-grade applications with role-based access systems. Collaborated in Agile teams with Sprint Planning and delivery. Built and published Own UI NPM Package.",
    highlights: [
      "Developed enterprise-grade applications with role-based access systems",
      "Collaborated in Agile teams with Sprint Planning and delivery",
      "Own UI NPM Package using for the applications",
    ],
    projects: [
      {
        name: "Cybersoft School Cafe Application",
        client: "Cybersoft Solution",
        period: "Aug 2021 – Aug 2022",
        role: "React Developer",
        tech: ["React", "TypeScript", "Redux"],
        description:
          "Enterprise school cafe management application with role-based access and permissions.",
        points: [
          "TypeScript, Redux, Roles and Permissions based implementation",
        ],
      },
      {
        name: "Store Control Systems – OPS Workbench",
        client: "7-Eleven",
        period: "Jun 2021 – Aug 2021",
        role: "ReactJS Developer",
        tech: ["React", "Material UI", "Ant Design", "Drag & Drop"],
        description:
          "Role-based application with hierarchy model for store managers. Features Question/Answer Module, Survey Module, and Task Allocation with drag-and-drop scheduling.",
        points: [
          "Role-based application with hierarchy model",
          "Question and Answer Module, Survey Module",
          "Task Allocation with Drag & Drop scheduled dates",
          "Material UI and Ant Design implementation",
        ],
      },
    ],
  },
  {
    id: "own-products",
    company: "Own Products / Freelance",
    location: "Coimbatore, India",
    period: "Feb 2021 – Jun 2021",
    isOnsite: false,
    summary:
      "Built personal React Native products with full stack capabilities including payments, maps, Firebase, and FCM notifications.",
    highlights: [
      "FCM, Payments Stripe, Firebase, Map Integration",
      "E-commerce React Native App with order tracking and payments",
      "Express Store – partially automated store purchasing",
    ],
    projects: [
      {
        name: "E-Commerce React Native App",
        role: "React Native Developer",
        tech: ["React Native", "Stripe", "Firebase", "FCM", "Maps"],
        description:
          "Online purchasing application with order status tracking, online payments, and profile maintenance.",
        points: [
          "Online Purchasing Application",
          "Order status tracking",
          "Online Payments",
          "Profile Maintenance",
        ],
      },
      {
        name: "Express Store React Native App",
        role: "React Native Developer",
        tech: ["React Native", "QR Auth", "AWS Amplify", "Maps"],
        description:
          "Partially automated store application allowing customers to purchase without cashier checkout.",
        points: [
          "Online Payments, Store Search and detail in Map",
          "QR Authentication",
          "AWS Amplify integration",
        ],
      },
    ],
  },
  {
    id: "katomaran",
    company: "Katomaran Technology Business Solution",
    location: "Coimbatore, India",
    period: "Jan 2020 – Feb 2021",
    isOnsite: false,
    summary:
      "Built IoT-enabled mobile apps and backend systems using React Native & Ruby on Rails. Deployed microservices using Docker. Integrated IoT systems using MQTT. Managed cloud environments on DigitalOcean.",
    highlights: [
      "Built IoT-enabled mobile apps and backend systems using React Native & Rails",
      "Developed App with Real-Time Notifications FCM and WebSockets",
      "Integrated IoT systems using MQTT and backend APIs",
      "Deployed microservices using Docker and managed cloud environments",
    ],
    projects: [
      {
        name: "Condo Management System",
        client: "Interlock Systems (Singapore)",
        role: "Full Stack Developer",
        tech: ["ReactJS", "Ruby on Rails", "PostgreSQL", "Docker"],
        description:
          "Dashboard with Block–Floor–Unit management, Residents list, Invite flow for condo admin and residents.",
        points: [
          "Dashboard, List of Block–Floor–Unit, List of Residents",
          "Invite flow for condo admin and residents",
        ],
      },
      {
        name: "Decann Pumps",
        client: "Interlock Systems (Singapore)",
        role: "Full Stack Developer",
        tech: ["ReactJS", "MQTT", "IoT", "Ruby on Rails"],
        description:
          "Dashboard for pump management with IoT control via MQTT server. Daily reports as graph, PDF, image and table records.",
        points: [
          "Dashboard, List of Pumps with individual pump details",
          "IoT device control using MQTT server",
          "Daily reports as graph, PDF, image and table",
        ],
      },
      {
        name: "Smart Condo Management App",
        client: "Interlock Systems (Singapore)",
        role: "React Native Developer",
        tech: ["React Native", "FCM", "Ruby on Rails", "WebSockets"],
        description:
          "Mobile app for condo residents to invite guests, manage complaints, and receive notifications.",
        points: [
          "Guest, Contractor, Delivery invitation system",
          "Complaint feature for residents",
          "FCM Notifications for complaints, visitor arrivals",
        ],
      },
    ],
  },
];

// ============================================================
// KEY LIVE PROJECTS
// ============================================================
export const keyLiveProjects = [
  {
    id: "metrash",
    name: "Metrash",
    subtitle: "Mobile Security Ecosystem",
    type: "institutional",
    category: "Mobile App",
    description:
      "Integrated security services platform designed for seamless citizen interaction and biometric authentication across government sectors.",
    tech: ["React Native", "Kony", "Volt MX", "Firebase", "Security Auth", "i18n"],
    image: MetrashImg,
    icon: "shield",
    link: null,
  },
  {
    id: "qatar-rail",
    name: "Qatar Rail",
    subtitle: "Web & Mobile Platform",
    type: "institutional",
    category: "Web & Mobile App",
    description:
      "End-to-end transportation management suite featuring real-time tracking, ticketing logic, and passenger data synchronization for Qatar's public transport system.",
    tech: ["VoltMX", "Kony", "Next.js", "GraphQL", "Leaflet.js", "i18n"],
    image: QatarRailImg,
    icon: "train",
    link: null,
  },
  {
    id: "hayya",
    name: "Hayya Platform",
    subtitle: "Web Platform",
    type: "institutional",
    category: "Event & Visa Management",
    description:
      "Sophisticated large-scale fan portal integrated with multiple national databases for event management and visitor authentication during FIFA World Cup Qatar 2022.",
    tech: ["Next.js", "Redux", "Enterprise React", "Identity Mgmt", "i18n"],
    image:
      "https://d12eu00glpdtk2.cloudfront.net/public/images/news/hayya-platform-processes-over-2-million-e-visa-applications-post-fifa-qatar-2022/_910x600_clip_center-center_none/hayya-platform-processes-over-2-million-e-visa-applications-post-fifa-qatar-2022.jpg",
    icon: "confirmation_number",
    link: null,
  },
  {
    id: "hukoomi",
    name: "Hukoomi AI",
    subtitle: "Government Portal with AI Chatbot",
    type: "institutional",
    category: "Web & Mobile App",
    description:
      "Chatbot integration for centralized government services utilizing NLP processing, OpenAI, and cognitive search.",
    tech: ["React", "Python", "OpenAI", "Azure", "Cognitive Search", "i18n"],
    image: HukoomiImg,
    icon: "smart_toy",
    link: null,
  },
  {
    id: "qatar-foundation",
    name: "Qatar Foundation",
    subtitle: "Enterprise Web Platform",
    type: "institutional",
    category: "Web Platform",
    description: "Enterprise web platform built using Gatsby for Qatar Foundation.",
    tech: ["Gatsby", "GraphQL", "React"],
    image: null,
    icon: "account_balance",
    link: null,
  },
  {
    id: "smart-condo",
    name: "Smart Condo",
    subtitle: "IoT Residential App",
    type: "institutional",
    category: "Mobile App",
    description:
      "IoT-enabled residential management app for Singapore condo residents with guest management, complaints, and real-time notifications.",
    tech: ["React Native", "Ruby on Rails", "IoT", "FCM", "WebSockets"],
    image: null,
    icon: "apartment",
    link: null,
  },
];

// ============================================================
// FREELANCE PROJECTS
// ============================================================
export const freelanceProjects = [
  {
    id: "yatra-connect",
    name: "Yatra Connect",
    subtitle: "Events, Approvals & Chat System",
    category: "Mobile App",
    description:
      "Your ultimate companion for discovering and participating in spiritual, cultural, and religious events across India. Features events, approvals, hierarchy, and chat system.",
    tech: ["React Native", "Ruby on Rails", "WebSocket", "Chat"],
    image: YatraConnectImg,
    icon: "flight_takeoff",
    link: null,
    infrastructure:
      "Using Raspberry Pi 5 (DietPi OS) as development server, migrating to production environments (AWS, GCP, DigitalOcean) after client approval.",
  },
  {
    id: "iotify",
    name: "IoTify",
    subtitle: "Smart Home Automation & AI Chatbot",
    category: "Web & Mobile App",
    description:
      "Smart home automation dashboard monitoring hardware states and executing conditional triggers via MQTT. Features ChatBot & Automation, Sharing Areas or Devices with other Users – Running Ollama using NVIDIA models.",
    tech: ["IoT", "MQTT", "FullStack", "AI Bot", "LLM Model", "Ollama", "NVIDIA"],
    image: IoTifyImg,
    icon: "settings_input_component",
    link: null,
  },
];

// ============================================================
// AI & LLM EXPERIENCE
// ============================================================
export const aiExperience = {
  level: "Beginner",
  highlights: [
    "Hands-on experience with Ollama for running local LLM models",
    "Integrated AI chatbot features into applications using API-based model interaction",
    "Worked on prompt engineering and response optimization for chatbot use-cases",
    "Explored model integration for automation, Q&A systems, and user assistance features",
    "Basic understanding of LLM workflows, embeddings, and conversational UI design",
    "Faster development using AI editors (Claude, Antigravity, Cursor)",
  ],
  tools: ["Ollama", "OpenAI API", "Claude", "Cursor", "Antigravity"],
  models: ["Llama 3", "NVIDIA models via Ollama"],
};

// ============================================================
// EDUCATION
// ============================================================
export const education = [
  {
    degree: "Master of Computer Applications",
    href: "https://kct.ac.in/",
    institution: "Kumaraguru College of Technology",
    focus: "Advanced Computational Logic & Systems Architecture",
    learnedIntro: "In Education I learned these:",
    topics: [
      "Machine Learning",
      "Artificial Intelligence",
      "IoT, Arduino, Raspberry Pi, Embeddings",
      "HTML, CSS, JS",
      "Python, C, C++",
      "Data Structures, Java",
    ],
  },
];

// ============================================================
// CONTACT INFO
// ============================================================
export const contact = {
  email: "dineshnataraj345@outlook.com",
  linkedin: "https://www.linkedin.com/in/dineshkumar-nataraj-a83ba2192/",
  gitlab: "https://gitlab.com/dinesh_kumar_dk",
  whatsapp: "+974 71271142",
  locations: [
    { city: "Doha", country: "Qatar", status: "ACTIVE" },
    { city: "Coimbatore", country: "India", status: "NATIVE" },
  ],
};

// ============================================================
// BLOG / ENGINEERING LOGS
// ============================================================
export const blogPosts = [
  {
    id: "scaling-react-native-gov",
    title: "Scaling React Native for Government Platforms",
    date: "March 14, 2024",
    readTime: "12 Min Read",
    category: "MOBILE ARCHITECTURE",
    featured: true,
    tags: ["React Native", "Security", "Architecture"],
    description:
      "Exploring the unique challenges of implementing high-security, accessible, and offline-first mobile applications using React Native for large-scale public sector initiatives.",
  },
  {
    id: "local-llms-ollama",
    title: "Local LLMs with Ollama",
    date: "February 28, 2024",
    readTime: "8 Min Read",
    category: "Infrastructure",
    featured: false,
    tags: ["LLM", "Ollama", "Privacy"],
    description:
      "Bridging the gap between cloud-based AI and local execution. A guide to deploying Llama 3 on consumer hardware with GPU acceleration and private data isolation.",
  },
  {
    id: "rpi-production-server",
    title: "Raspberry Pi as Production Server",
    date: "February 15, 2024",
    readTime: "15 Min Read",
    category: "Infrastructure",
    featured: false,
    tags: ["IoT", "Hardware", "DevOps"],
    description:
      "De-risking ARM-based edge computing. How we utilized Raspberry Pi 5 clusters for localized data processing and persistent nodes in remote environments.",
  },
];
